
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer/add-game",
      function () {
        return require("private-next-pages/developer/add-game/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer/add-game"])
      });
    }
  